import { useState, type CSSProperties } from "react";
import { useTranslation } from "react-i18next";
import Popup from "src/components/Popup/Popup";
import { getTagStyle } from "src/helpers/randomColor";
import type { Tag } from "src/types";

interface Props {
    tags: Tag[];
    currentTagIds: string[];
    onChange: (tagIds: string[]) => void;
    onClose: () => void;
}

export function InvoiceTagsPopup({ tags, currentTagIds, onChange, onClose }: Props) {
    const { t } = useTranslation();
    // Tracked locally so a click reflects instantly instead of waiting on the PATCH + refetch round trip.
    const [selected, setSelected] = useState<Set<string>>(new Set(currentTagIds));

    const handleClick = (tagId: string) => {
        const next = new Set(selected);
        next.has(tagId) ? next.delete(tagId) : next.add(tagId);
        setSelected(next);
        onChange([...next]);
    };

    return (
        <Popup
            title={t("tags.manageTags")}
            onClose={onClose}
            actions={[{ label: t("popup.done"), variant: "primary", onClick: onClose }]}
            message={
                tags.length ? (
                    <div className="inv-filter__chips invoice-tags-popup__chips">
                        {tags.map((tag) => (
                            <button
                                key={tag.id}
                                type="button"
                                className={`inv-filter__chip inv-filter__chip--tag${selected.has(tag.id) ? " inv-filter__chip--active" : ""}`}
                                style={getTagStyle(tag.name) as CSSProperties}
                                onClick={() => handleClick(tag.id)}
                            >
                                {tag.name}
                            </button>
                        ))}
                    </div>
                ) : (
                    <p className="invoice-tags-popup__empty">{t("tags.noTags")}</p>
                )
            }
        />
    );
}

export default InvoiceTagsPopup;
